import { render, staticRenderFns } from "./pint90x95.vue?vue&type=template&id=5cac8f65&scoped=true&"
import script from "./pint90x95.vue?vue&type=script&lang=js&"
export * from "./pint90x95.vue?vue&type=script&lang=js&"
import style0 from "./pint90x95.vue?vue&type=style&index=0&id=5cac8f65&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac8f65",
  null
  
)

export default component.exports